// Version is bumped automatically by release-please. See release-please-config.json.

'use strict'
const version = '5.2.7'; // x-release-please-version
export default version;
